import { observable, computed, /* action,, when when*/} from 'mobx';
//import { comm } from '../../comm';
//import { integration } from '../../integration';
import { Xp } from './Xp';
import { Account } from './Account';
//import { FacebookAccount } from './FacebookAccount';
//import { GuestAccount } from './GuestAccount';
//import { store } from '../mainStore';
//import {HaloAccount} from './HaloAccount';

export class User {
	constructor(parent) {
		this.parent = parent;
	}

	xpData = new Xp();
	@observable siuEmail = '';
	@observable lastBetAmount = 10000;
	@computed get hasSeenOrSkippedTutorial() {
		return this.hasSeenTutorial || localStorage.getItem('skippedTutorial') === 'yes';
	}
	@observable hasSeenTutorial = false;

	@computed get level() {
		return this.xpData.currentLevel;
	}

	guest = new Account(this, 'guest', 'anon');
	
	@observable isReady = false;
	@observable loginConfirmed = false;
	@computed get notGuest() { 		return false;}
	@computed get mustLogin() { 	return false;}
}
